import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal } from "@/components/Reveal";

const Counter = ({ value, prefix = "", testid }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 1.9,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <span ref={ref} data-testid={testid} className="tabular-nums">
      {prefix}
      {display}
    </span>
  );
};

const STATS = [
  { value: 60, prefix: "+", label: "años de experiencia", testid: "stat-anos" },
  { value: 3, prefix: "", label: "generaciones de asesores", testid: "stat-generaciones" },
  { value: 100, prefix: "+", label: "clientes que confían en nosotros", testid: "stat-clientes" },
  { value: 5, prefix: "", label: "aseguradoras líderes", testid: "stat-aseguradoras" },
];

export const Stats = () => (
  <section data-testid="stats-section" className="relative z-10 bg-[#E8F6FD]">
    <div className="mx-auto grid max-w-7xl grid-cols-2 gap-x-6 gap-y-10 px-5 py-14 sm:px-8 lg:grid-cols-4 lg:py-16">
      {STATS.map((stat, i) => (
        <Reveal key={stat.testid} delay={i * 0.12} className="text-center">
          <div className="font-display text-4xl font-extrabold text-[#0C5F8A] sm:text-5xl">
            <Counter value={stat.value} prefix={stat.prefix} testid={stat.testid} />
          </div>
          <div className="mx-auto mt-2 h-1 w-10 rounded-full bg-[#F5B21B]" />
          <p className="mt-3 text-sm font-medium text-[#2E3338]/80 sm:text-base">{stat.label}</p>
        </Reveal>
      ))}
    </div>
  </section>
);
